import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TravelArticle } from '../models/travel-article.model';


@Injectable({
  providedIn: 'root'
})
export class TravelArticlesService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * returns Array of Travel Articles for an airport
   */
  async getArticles(ident: string): Promise<TravelArticle[]> {
    const URL = `${environment.travelArticleApiUrl}&airportident=${ident}`;
    try {
      let RESPONSE: any = await this._http.get(URL).toPromise();
      // let RESPONSE = await this._http.get<any>(`assets/sample/travel/${ident}.json`).toPromise();

      if (!RESPONSE) {
        return ([]).map(d => TravelArticle.parse(d));
        // this._errorHandler.handleError(new Error('API did not return valid countries Obj'));
      } else {
        // return (RESPONSE || []).map(d => TravelArticle.parse(d));
        RESPONSE = RESPONSE.DestinationsArticles.Articles;
        return (RESPONSE || []).map(d => TravelArticle.parse(d)).filter(f => f.Topics.includes('destinations'));
      }
    } catch (e) {
      // this._errorHandler.handleError(e);
      // throw e;
      return ([]).map(d => TravelArticle.parse(d));
    }
  }

}
